export default "__VITE_ASSET__a682c158__"